import {rememberSelection, tourParameters, track} from '../../analytics/bookingAnalytics';
import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker-Custom.css";
import {format} from 'date-fns';
import s from './BookNow.module.scss';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import LoadingInside from "../../components/Loading/LoadingInside";
import ExtrasPickupStep from "./ExtrasPickupStep";
import RecommendationPopup from "./RecommendationPopup";

const REZDY_BASE_URL = process.env.REACT_APP_API_LOCAL_URL;

const BookNow = ({
                     tour,
                     plans,
                     isCombo = false,
                     combo = null,
                     activeTour = null,
                     onComboTourCompleted
                 }) => {
    const navigate = useNavigate();
    const [availability, setAvailability] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);
    const [availableTimes, setAvailableTimes] = useState([]); // New: Times for selected date
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [openParticipants, setOpenParticipants] = useState(false);
    const availabilityTracked = useRef(null);
    const popupRef = useRef(null);
    const containerRef = useRef(null);
    const [showStickyBtn, setShowStickyBtn] = useState(true);

    const [minAllowedDate, setMinAllowedDate] = useState(null);

    const [showExtrasPopup, setShowExtrasPopup] = useState(false);
    const [pendingBookingData, setPendingBookingData] = useState(null);

    const [showRecommendationPopup, setShowRecommendationPopup] = useState(false);

    const [recommendations, setRecommendations] = useState([]);

    const [comboOffers, setComboOffers] = useState([]);

    const [loadingRecommendations, setLoadingRecommendations] = useState(false);


    const [cartItems, setCartItems] = useState(() => {
        return JSON.parse(localStorage.getItem("booking_cart") || "[]");
    });
    const isComboMode = isCombo && combo?.tours?.length > 0;

    const currentIndex = isComboMode
        ? combo.tours.findIndex(
            t => t.tour_id === activeTour?.tour_id
        )
        : -1;
    const remainingTours = isComboMode
        ? combo.tours.slice(currentIndex + 1)
        : [];

    const goToNextTour = () => {
        const next = remainingTours[0];

        if (next) {
            onComboTourCompleted?.(next);
        }
    };

    const isLastComboTour =
        isComboMode
            ? currentIndex === combo.tours.length - 1
            : true;
    const resetBooking = () => {
        setSelectedDate(null);
        setSelectedSession(null);
        setSelectedPlan(null);
        setQuantities({});
    };
    const isCurrentTourInCart = () => {
        return cartItems.some(
            item => item.productCode === product?.productCode
        );
    };

    const alreadyInCart = isComboMode && isCurrentTourInCart();

    const areAllComboToursInCart = () => {
        const cart = JSON.parse(localStorage.getItem("booking_cart") || "[]");

        if (!isComboMode) return false;

        return combo.tours.every(tour =>
            cart.some(
                item => item.productCode === tour.rezdy_id
            )
        );
    };
    const handleAfterBooking = () => {
        saveToCart();
        setShowExtrasPopup(false);
        resetBooking();

        if (isComboMode && remainingTours.length > 0) {
            onComboTourCompleted?.(remainingTours[0]);
            return;
        }

        handleRecommendation(true)
    };
    const handleRecommendation =  (checkout=false) => {
        setShowExtrasPopup(false);
        // If every combo tour is already in cart, go directly to cart

        console.log(areAllComboToursInCart())
        if (isComboMode && areAllComboToursInCart()) {
            navigate("/cart");
            return;
        }

        loadRecommendations(checkout);
    };

    useEffect(() => {
        if (availability.length > 0 && product?.minimumNoticeMinutes != null) {

            const minutes = Number(product.minimumNoticeMinutes);

            let earliest;

            if (!tour.last_min_available) {
                earliest = getMinDateOnly(minutes);
            } else {
                earliest = new Date(); // today allowed
                earliest.setHours(0, 0, 0, 0);
            }

            setMinAllowedDate(earliest);

        }
    }, [availability, product, tour]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError('');

            const productCode = tour.rezdy_id || tour.rezdyId || '';
            const startDate = new Date();
            if (!productCode) {
                setError('Product code is missing.');
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(`${REZDY_BASE_URL}availability`, {
                    params: {
                        productCode,
                        startTime: format(startDate, 'yyyy-MM-dd'),
                    }
                });

                const allSessions = response.data.data?.availability?.sessions || [];

// 🔥 remove full/invalid sessions
                const filteredSessions = allSessions.filter(
                    s => (s.seatsAvailable ?? 0) > 0
                )
                setAvailability(filteredSessions);

                // product info (take from first response)
                setProduct(
                    response.data.data?.product?.product || {}
                );

            } catch (err) {
                setError('空き状況の読み込みに失敗しました。もう一度お試しください。');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [tour]);

    // When date changes → filter available times for that date
    useEffect(() => {
        if (selectedDate) {
            const dateStr = format(selectedDate, 'yyyy-MM-dd');

            const firstTime = availability.find(
                s =>
                    format(new Date(s.startTimeLocal), 'yyyy-MM-dd') === dateStr
            );

            const times = firstTime ? [firstTime] : [];


            setAvailableTimes(times);

            if (times.length === 1) {
                setSelectedSession(times[0]);
            } else {
                setSelectedSession(null);
            }

            setSelectedPlan(null);
        } else {
            setAvailableTimes([]);
            setSelectedSession(null);
            setSelectedPlan(null);
        }
    }, [selectedDate, availability]);

    useEffect(() => {
        setQuantities({});
    }, [selectedDate, selectedPlan]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setOpenParticipants(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();

            const isVisible =
                rect.top <= window.innerHeight && rect.bottom >= 0;

            setShowStickyBtn(!isVisible);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getMinDateOnly = (minutes) => {
        const now = new Date();

        const cutoff = new Date(now.getTime() + minutes * 60 * 1000);

        // 👉 strip time completely
        cutoff.setHours(0, 0, 0, 0);

        return cutoff;
    };
    const getPlanPrices = () => {
        if (!selectedPlan || !selectedDate) return {};

        const now = new Date();
        const diffHours = (selectedDate - now) / (1000 * 60 * 60);

        const isEarlyBird = diffHours >= (tour.early_bird_time || 0);

        return {
            ad: isEarlyBird && selectedPlan.eb_ad_price ? selectedPlan.eb_ad_price : selectedPlan.ad_price,
            ch: isEarlyBird && selectedPlan.eb_ch_price ? selectedPlan.eb_ch_price : selectedPlan.ch_price,
            family: isEarlyBird && selectedPlan.eb_family_price ? selectedPlan.eb_family_price : selectedPlan.family_price,
            inf: isEarlyBird && selectedPlan.eb_inf_price ? selectedPlan.eb_inf_price : selectedPlan.inf_price,
        };
    };

    const handleQuantityChange = (optionId, delta) => {
        const next = {...quantities, [optionId]: Math.max(0, (quantities[optionId] || 0) + delta)};
        if (next[optionId] === (quantities[optionId] || 0)) return;
        track('select_tour_participants', selectionParameters(next));
        setQuantities(next);
    };

    const handleContinue = () => {
        if (!selectedSession || totalParticipants === 0) {
            setError('日付、時間、少なくとも1名の参加者を選択してください。');
            return;
        }

        const parameters = selectionParameters();
        const signature = JSON.stringify(parameters);
        if (availabilityTracked.current !== signature) {
            if (track('check_availability', parameters)) availabilityTracked.current = signature;
        }
        setPendingBookingData({
            selectedSession,
            quantities,
            totalParticipants,
            product,
            extras: {}
        });
        setShowExtrasPopup(true);
    };

    if (loading) return <LoadingInside height={"40vh"}/>;


    const isLastMinute = () => {
        if (!selectedDate) return false;

        const now = new Date();
        const diffHours = (selectedDate - now) / (1000 * 60 * 60);

        return tour.last_min_available && diffHours <= tour.last_minit_time;
    };

    const getLastMinuteOption = () => {
        if (!isLastMinute() || !selectedPlan || !selectedSession) return null;

        const label = selectedPlan.last_min_price;

        return selectedSession.priceOptions.find(o => o.label === label);
    };

    const availableDates = availability
        .map(s => new Date(s.startTimeLocal))
        .filter(date => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);

            const min = new Date(minAllowedDate);
            min.setHours(0, 0, 0, 0);

            return d > min;
        });
    const normalizedMinDate = new Date(minAllowedDate);
    normalizedMinDate.setHours(0, 0, 0, 0);
    const getLabelType = (label) => {
        const prices = getPlanPrices();

        if (label === prices.ad) return 'Adult';
        if (label === prices.ch) return 'Child';
        if (label === prices.family) return 'Family';
        if (label === prices.inf) return 'Infant';

        return label;
    };
    const prices = getPlanPrices();
    const getOrderedOptions = () => {
        const prices = getPlanPrices();
        if (!selectedSession) return [];

        const order = [
            {key: 'Adult', label: prices.ad},
            {key: 'Child', label: prices.ch},
            {key: 'Infant', label: prices.inf},
            {key: 'Family', label: prices.family},
        ];

        return order
            .map(item => {
                const option = selectedSession.priceOptions.find(
                    o => o.label === item.label
                );

                if (!option) return null;

                // find matching plan (IMPORTANT PART)
                const plan = plans?.find(p =>
                    [p.ad_price, p.eb_ad_price, p.ch_price, p.eb_ch_price, p.family_price, p.eb_family_price, p.inf_price, p.eb_inf_price]
                        .includes(option.label)
                );

                return {
                    ...option,
                    displayName: item.key,
                    note:
                        item.key === 'Adult' ? plan?.adult_note :
                            item.key === 'Child' ? plan?.child_note :
                                item.key === 'Infant' ? plan?.infant_note :
                                    item.key === 'Family' ? plan?.family_note :
                                        ''
                };
            })
            .filter(Boolean);
    };




    const orderedOptions = getOrderedOptions();
    const noParticipantOptions =
        selectedSession &&
        selectedPlan &&
        orderedOptions.length === 0;
    const participantDisabled =
        !selectedSession || !selectedPlan || noParticipantOptions;

    const calculateTotalSeatsRequired = () => {
        if (!selectedSession) return 0;

        return orderedOptions.reduce((total, option) => {
            const qty = quantities[option.id] || 0;
            const seatsUsed = option.seatsUsed || 1;

            return total + (qty * seatsUsed);
        }, 0);
    };
    const totalParticipants = calculateTotalSeatsRequired();
    const getPricingMode = () => {
        if (!selectedDate) return null;

        const now = new Date();
        const diffHours = (selectedDate - now) / (1000 * 60 * 60);

        if (tour.last_min_available && diffHours <= tour.last_minit_time) {
            return 'last_min';
        }

        if (tour.eary_bird_available && diffHours >= tour.early_bird_time) {
            return 'early_bird';
        }

        return 'normal';
    };
    const pricingMode = getPricingMode();
    const getDisplayPrices = () => {
        if (!plans?.length || !product?.priceOptions) return [];

        const isEBEnabled = tour?.eary_bird_available === 1;
        const ebHours = tour?.early_bird_time || 0;

        const resolve = (label) => {
            const opt = product.priceOptions.find(
                p => p.label === label
            );
            return opt?.price ?? null;
        };

        const mapped = plans.map(plan => ({
            plan,
            adultNormal: resolve(plan.ad_price),
            adultEarly: resolve(plan.eb_ad_price),

            childNormal: resolve(plan.ch_price),
            childEarly: resolve(plan.eb_ch_price),

            familyNormal: resolve(plan.family_price),
            familyEarly: resolve(plan.eb_family_price),
        }));

        const validNormal = mapped.filter(
            p => p.adultNormal !== null
        );

        if (!validNormal.length) return [];

        const lowestNormal = validNormal.reduce((min, curr) =>
            curr.adultNormal < min.adultNormal ? curr : min
        );

        const validEarly = isEBEnabled
            ? mapped.filter(p => p.adultEarly !== null)
            : [];

        const lowestEarly = validEarly.length
            ? validEarly.reduce((min, curr) =>
                curr.adultEarly < min.adultEarly ? curr : min
            )
            : null;

        const result = [];

        // SAME PLAN
        if (
            lowestEarly &&
            lowestEarly.plan.id === lowestNormal.plan.id
        ) {
            return [{
                planId: lowestNormal.plan.id,
                planName: lowestNormal.plan.campaign,
                type: "both",

                adultPrice: lowestNormal.adultNormal,
                adultEarlyPrice: lowestNormal.adultEarly,

                childPrice: lowestNormal.childNormal,
                childEarlyPrice: lowestNormal.childEarly,

                familyPrice: lowestNormal.familyNormal,
                familyEarlyPrice: lowestNormal.familyEarly,

                isEarlyBirdAvailable: !!lowestNormal.adultEarly,
                earlyBirdHours: ebHours,
            }];
        }

        // NORMAL PLAN
        result.push({
            planId: lowestNormal.plan.id,
            planName: lowestNormal.plan.campaign,
            type: "normal",

            adultPrice: lowestNormal.adultNormal,
            adultEarlyPrice: lowestNormal.adultEarly,

            childPrice: lowestNormal.childNormal,
            childEarlyPrice: lowestNormal.childEarly,

            familyPrice: lowestNormal.familyNormal,
            familyEarlyPrice: lowestNormal.familyEarly,

            isEarlyBirdAvailable: !!lowestNormal.adultEarly,
            earlyBirdHours: ebHours,
        });

        // EARLY BIRD PLAN
        if (lowestEarly) {
            result.push({
                planId: lowestEarly.plan.id,
                planName: lowestEarly.plan.campaign,
                type: "early_bird",

                adultPrice: lowestEarly.adultNormal,
                adultEarlyPrice: lowestEarly.adultEarly,

                childPrice: lowestEarly.childNormal,
                childEarlyPrice: lowestEarly.childEarly,

                familyPrice: lowestEarly.familyNormal,
                familyEarlyPrice: lowestEarly.familyEarly,

                isEarlyBirdAvailable: !!lowestEarly.adultEarly,
                earlyBirdHours: ebHours,
            });
        }

        return result;
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2
        }).format(price);
    };

    const formatDisplayPrice = (price) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0
        }).format(price);
    };

    const getParticipantSummary = () => {
        const items = getOrderedOptions()
            .map(option => {
                const qty = quantities[option.id] || 0;

                if (qty === 0) return null;

                return `${translateLabel(getLabelType(option.label))} x${qty}`;
            })
            .filter(Boolean);

        if (items.length === 0) return '参加者を選択';

        return items.join(', ');
    };

    const scrollToSelf = () => {
        const y = containerRef.current.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({top: y, behavior: 'smooth'});
    };
    const getFromPrice = () =>
        getDisplayPrices().find(p => p.name === '大人')?.price || null;

    const displayPrices = getDisplayPrices();
    if (displayPrices.length === 0) {
        return (
            <div className={` p-2 ${s.container}`}>
                <Alert severity="error">
                    現在このツアーは予約できません。料金情報が見つかりませんでした。
                </Alert>
            </div>
        );
    }
    const translateLabel = (label) => {
        const map = {
            Adult: "大人",
            Child: "子供",
            Infant: "幼児",
            Family: "ファミリー",
        };

        return map[label] || label;
    };
    const calculateTotalPrice = () => {
        let total = 0;

        orderedOptions.forEach(option => {
            const qty = quantities[option.id] || 0;
            total += option.price * qty;
        });

        // Add last minute fee if applicable
        if (isLastMinute() && getLastMinuteOption()) {
            total += getLastMinuteOption().price * calculateTotalSeatsRequired();
        }

        return total;
    };
    const selectionParameters = (counts = quantities) => ({
        ...tourParameters(tour),
        plan_id: selectedPlan ? String(selectedPlan.id) : undefined,
        plan_name: selectedPlan?.campaign,
        selected_date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : undefined,
        adults: orderedOptions.filter(o => getLabelType(o.label) === 'Adult').reduce((n, o) => n + (counts[o.id] || 0), 0),
        children: orderedOptions.filter(o => getLabelType(o.label) === 'Child').reduce((n, o) => n + (counts[o.id] || 0), 0),
        currency: product.currency || 'AUD',
        value: orderedOptions.reduce((n, o) => n + o.price * (counts[o.id] || 0), 0)
    });
    const getEarlyBirdDeadline = () => {
        const now = new Date();
        return new Date(now.getTime() + (tour.early_bird_time * 60 * 60 * 1000));
    };
    const earlyBirdDeadline = getEarlyBirdDeadline();


    const getEarlyBirdInfo = () => {
        return {
            available: tour?.eary_bird_available === 1,
            hours: tour?.early_bird_time || 0
        };
    };
    const earlyBird = getEarlyBirdInfo();

    const formattedEarlyBirdDeadline = format(
        earlyBirdDeadline,
        'MM/dd'
    );
    const sortedDisplayPrices = [...getDisplayPrices()].sort((a, b) => {
        if (a.isEarlyBirdAvailable && !b.isEarlyBirdAvailable) return -1;
        if (!a.isEarlyBirdAvailable && b.isEarlyBirdAvailable) return 1;
        return 0;
    });

    const selectedDateSessions = selectedDate
        ? availability.filter(s =>
            format(new Date(s.startTimeLocal), 'yyyy-MM-dd') ===
            format(selectedDate, 'yyyy-MM-dd')
        )
        : [];

    const seatsRequired = calculateTotalSeatsRequired();

    const seatsAvailable = selectedSession?.seatsAvailable || 0;

    const isOverCapacity = seatsRequired > seatsAvailable;


    const saveToCart = (extras = {}) => {

        const item = buildDraftBookingItem();
        rememberSelection(item.productCode, selectionParameters(), item.startTimeLocal);
        saveOrUpdateCartItem(item);
        // const existing = JSON.parse(localStorage.getItem("booking_cart") || "[]");

        // const updated = [...existing, item];
        //
        // localStorage.setItem("booking_cart", JSON.stringify(updated));

        window.dispatchEvent(new Event("cartUpdated"));
    };
    const buildDraftBookingItem = () => ({
        productCode: product.productCode,
        productName: product.name,
        startTimeLocal: selectedSession.startTimeLocal,

        quantities: selectedSession.priceOptions
            .map(option => ({
                priceOptionId: option.id,
                optionLabel: option.label,
                value: pendingBookingData.quantities[option.id] || 0
            }))
            .filter(q => q.value > 0),

        extras: Object.entries(pendingBookingData.extras)
            .filter(([, quantity]) => quantity > 0)
            .map(([name, quantity]) => ({
                name,
                quantity
            })),

        fields: product.bookingFields || [],

        participants: Array.from(
            {length: pendingBookingData.totalParticipants || 0},
            () => ({fields: []})
        ),

        pickup: '',
        pickupListId: product?.pickupId

    });

    const saveOrUpdateCartItem = (item) => {
        const existingIndex = cartItems.findIndex(
            cartItem =>
                cartItem.productCode === item.productCode &&
                cartItem.startTimeLocal === item.startTimeLocal
        );

        let updated;

        if (existingIndex !== -1) {
            // Update existing item
            updated = [...cartItems];
            updated[existingIndex] = item;
        } else {
            // Add new item
            updated = [...cartItems, item];
        }

        setCartItems(updated);

        localStorage.setItem(
            "booking_cart",
            JSON.stringify(updated)
        );

        window.dispatchEvent(
            new Event("cartUpdated")
        );

        return updated;
    };

    const loadRecommendations =  (checkout) => {
        navigate("/recommendations", {
            state: {
                tourId: tour.tour_id,
                checkout:checkout
            }
        });
        // // setLoadingRecommendations(true);
        //
        // try {
        //
        //     const res = await axios.get(
        //         `${process.env.REACT_APP_API_URL}/api/tours/${tour.tour_id}/recommendations`
        //     );
        //
        //     setRecommendations(res.data.data.recommendedTours || []);
        //
        //     setComboOffers(res.data.data.comboOffers || []);
        //
        //     // setShowRecommendationPopup(true);
        //     navigate("/recommendations", {
        //         state: {
        //             comboOffers,
        //             recommendations
        //         }
        //     });
        //
        // } catch (e) {
        //
        //     navigate("/cart");
        //
        // } finally {
        //
        //     // setLoadingRecommendations(false);
        //
        // }
    };
    if (alreadyInCart) {
        return (
            <div ref={containerRef} className={s.container}>
                <div className={s.bookingCard}>

                    <div className={s.alreadyAdded}>
                        <h3>このツアーはすでに追加されています。</h3>

                        <p>
                            このツアーはすでにカートに追加されています。
                        </p>

                        {!isLastComboTour ? (
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={goToNextTour}
                            >
                                次のツアーへ進む。
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => loadRecommendations(true)}
                            >
                                続ける
                            </Button>
                        )}
                    </div>

                </div>
                {showStickyBtn && (
                    <div className={s.stickyBar}>
                        <div
                            className={s.stickyBtn}
                            onClick={scrollToSelf}
                        >
                            <div className={s.left}>
                                <div className={s.price}>
                                    から <span> {formatPrice(getFromPrice())}</span>
                                </div>

                            </div>

                            <div className={s.right}>
                                <div className={s.booknow}>
                                    今すぐ予約
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    return (
        <div ref={containerRef} className="min-h-screen bg-gray-100 py-10">
            <div className={s.container}>

                {error && <Alert severity="error" className="mb-4">{error}</Alert>}

                <div className={s.bookingCard}>

                    {/* TITLE */}
                    {/*<h3 className={s.title}>予約する</h3>*/}

                    {/* PRICE SUMMARY */}
                    {product?.priceOptions && (
                        <div className={s.priceSummary}>


                            <div className={s.priceList}>
                                {earlyBird.available && (
                                    <div className={s.priceItem}>
                                        <strong> {formattedEarlyBirdDeadline}以降なら早割{earlyBird.hours}適用！</strong>
                                    </div>
                                )}
                                {sortedDisplayPrices.map((item, idx) => (
                                    <div key={idx}
                                         className={`${s.priceItem}  ${item.isEarlyBirdAvailable && s.earlyBird}`}>
                                        <div className={`${s.priceCard} `}>
                                            <div className={s.priceRow}>
                                                <div className={"d-flex"}>
                                                    <div className="BookNow_priceLabel__2fnir">大人</div>
                                                    <div className={s.mainPrice}>{formatPrice(item.adultPrice)}</div>
                                                </div>

                                                {item.isEarlyBirdAvailable && <div
                                                    className={s.badge}>早割: {formatPrice(item.adultEarlyPrice)}</div>}
                                            </div>

                                            <div className={s.note}>
                                                <span className={s.planSmall}> {item.planName}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <label>【前日の空き状況確認】LINEからお気軽にお問合せを！</label>
                    {/* DATE */}
                    <div className={s.section}>

                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => {
                                if (date && (!selectedDate || format(date, 'yyyy-MM-dd') !== format(selectedDate, 'yyyy-MM-dd'))) {
                                    track('select_tour_date', {...tourParameters(tour), selected_date: format(date, 'yyyy-MM-dd')});
                                }
                                setSelectedDate(date);
                                setSelectedSession(null);
                            }}
                            includeDates={availableDates}
                            minDate={normalizedMinDate}
                            className={s.input}
                            placeholderText="日付を選択"
                        />
                    </div>

                    {/* TIME */}
                    {selectedDate && (
                        <div className={s.section}>

                            {availableTimes.length === 0 ? (
                                <span className={s.empty}>利用可能な時間なし</span>
                            ) : (
                                <>
                                    {/* Show time selector only when multiple sessions exist */}
                                    {availableTimes.length > 1 && (
                                        <select
                                            className={s.input}
                                            value={selectedSession?.startTimeLocal || ''}
                                            onChange={(e) => {
                                                const session = availableTimes.find(
                                                    s => s.startTimeLocal === e.target.value
                                                );

                                                setSelectedSession(session || null);
                                                setSelectedPlan(null);
                                            }}
                                        >
                                            <option value="">時間を選択</option>

                                            {availableTimes.map((session) => (
                                                <option
                                                    key={session.startTimeLocal}
                                                    value={session.startTimeLocal}
                                                >
                                                    {format(new Date(session.startTimeLocal), 'h:mm a')}
                                                    {" - "}
                                                    {format(new Date(session.endTimeLocal), 'h:mm a')}
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    {/* Show plan selector once a session is selected */}
                                    {selectedSession && (
                                        <select
                                            className={s.select}
                                            value={selectedPlan?.id || ''}
                                            onChange={(e) => {
                                                const plan = plans.find(
                                                    p => p.id === Number(e.target.value)
                                                );

                                                if (plan && plan.id !== selectedPlan?.id) {
                                                    track('select_tour_plan', {...selectionParameters(), plan_id: String(plan.id), plan_name: plan.campaign, adults: 0, children: 0, value: 0});
                                                }
                                                setSelectedPlan(plan || null);
                                            }}
                                        >
                                            <option value="">プランを選択してください</option>

                                            {plans.map(plan => (
                                                <option key={plan.id} value={plan.id}>
                                                    {plan.campaign}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                    {/* PRICING MODE MESSAGE */}
                    {selectedDate && pricingMode && (
                        <div className={s.pricingMessage}>
                            {pricingMode === 'last_min' && '⚠️ 直前価格'}
                            {pricingMode === 'early_bird' && '🎉 早割適用'}
                            {pricingMode === 'normal' && '通常料金'}
                        </div>
                    )}
                    {/* PARTICIPANTS */}
                    <div className={s.section} ref={popupRef}>

                        {/* PLACEHOLDER (summary + click) */}
                        <div
                            className={`${s.placeholder} ${participantDisabled ? s.disabled : ''}`}
                            onClick={() => {
                                if (!participantDisabled) {
                                    setOpenParticipants(prev => !prev);
                                }
                            }}
                        >
                            <div>
                                <div className={s.placeholderTitle}>
                                    参加人数
                                </div>

                                <div className={s.placeholderSub}>
                                    {getParticipantSummary()}
                                </div>
                            </div>

                            <div className={s.arrow}>
                                ▼
                            </div>
                        </div>
                        {selectedPlan && noParticipantOptions && (
                            <div className={s.errorMsg}>
                                参加可能な料金オプションがありません。
                            </div>
                        )}
                        {/* POPUP */}
                        {openParticipants && selectedSession && (
                            <div className={s.popup} onClick={(e) => e.stopPropagation()}>
                                <label>参加人数</label>

                                <div className={s.participantsBox}>
                                    {orderedOptions.map(option => (
                                        <div key={option.id}>
                                            <div className={s.participantRow}>

                                                <div>
                                                    <div className={s.label}>
                                                        {translateLabel(option.displayName)}
                                                    </div>

                                                    {/*<div className={s.price}>*/}
                                                    {/*    {formatPrice(option.price)}*/}
                                                    {/*</div>*/}

                                                    <div className={"d-inline-flex"}>
                                                        <div className={s.price}>
                                                            {formatPrice(option.price)}
                                                        </div>
                                                        {(quantities[option.id] || 0) > 0 && (
                                                            <div className={s.price}>
                                                                × {quantities[option.id]} ={" "}
                                                                <strong>
                                                                    {formatPrice(option.price * quantities[option.id])}
                                                                </strong>
                                                            </div>
                                                        )}
                                                    </div>


                                                </div>

                                                <div className={s.counter}>
                                                    <button onClick={() => handleQuantityChange(option.id, -1)}>-
                                                    </button>
                                                    <span>{quantities[option.id] || 0}</span>
                                                    <button onClick={() => handleQuantityChange(option.id, 1)}>+
                                                    </button>
                                                </div>

                                            </div>
                                            {/* ✅ Note under price */}
                                            {option.note && (
                                                <div className={s.note}>
                                                    {option.note}
                                                </div>


                                            )}
                                            <div className={s.space}>

                                            </div>
                                        </div>
                                    ))}
                                    {isOverCapacity && (
                                        <div className={s.errorMsg}>
                                            選択人数が空き枠（{seatsAvailable}席）を超えています。調整してください。
                                        </div>
                                    )}
                                    {isLastMinute() && getLastMinuteOption() ? (
                                        <div className={s.lastMinute}>
                                            ⚠️
                                            直前予約手数料: {formatPrice(getLastMinuteOption().price)} * {calculateTotalSeatsRequired()}
                                        </div>
                                    ) : <></>}
                                </div>
                                <div className={s.totalPrice}>
                                    合計金額: <strong>{formatPrice(calculateTotalPrice())}</strong>
                                </div>

                                {/* CLOSE BUTTON */}
                                <div className={s.closeBtn}>
                                    <button onClick={() => setOpenParticipants(false)}>
                                        次へ進む
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {(!openParticipants) && <div className={s.totalPrice}>
                        {isOverCapacity ? (
                            <div className={s.errorMsg}>
                                選択人数が空き枠（{seatsAvailable}席）を超えています。調整してください。
                            </div>
                        ): <> 合計金額: <strong>{formatPrice(calculateTotalPrice())}</strong></>}

                    </div>}

                    {/* CTA */}
                    <Button
                        className={s.booknowBtn}
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={handleContinue}
                        disabled={!selectedSession || totalParticipants === 0 || openParticipants || isOverCapacity}
                    >
                        予約詳細へ進む
                    </Button>

                </div>
            </div>
            {showStickyBtn && (
                <div className={s.stickyBar}>
                    <div
                        className={s.stickyBtn}
                        onClick={scrollToSelf}
                    >
                        <div className={s.left}>
                            <div className={s.price}>
                                から <span> {formatPrice(getFromPrice())}</span>
                            </div>

                        </div>

                        <div className={s.right}>
                            <div className={s.booknow}>
                                今すぐ予約
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showExtrasPopup && (
                <div className={s.modalOverlay}>
                    <div className={s.modalContent}>

                        <div className={"container"}>

                            <ExtrasPickupStep
                                product={product}
                                formData={{extras: pendingBookingData?.extras || {}}}
                                updateExtra={(name, qty) => {
                                    setPendingBookingData(prev => {
                                        const current = prev || {};

                                        return {
                                            ...current,
                                            extras: {
                                                ...(current.extras || {}),
                                                [name]: Math.max(0, qty)
                                            }
                                        };
                                    });
                                }}
                            />

                            <div className={"row p-3"}>

                                {/*<Button*/}
                                {/*    variant="outlined"*/}
                                {/*    disabled*/}
                                {/*>*/}
                                {/*    戻る*/}
                                {/*</Button>*/}
                                <div className={"col-12 col-md-6 mb-3"}>

                                    <Button
                                        className={"btnBlock"}
                                        variant="outlined"
                                        onClick={() => {
                                            saveToCart();
                                            setShowExtrasPopup(false);
                                            resetBooking();

                                            if (isComboMode && !isLastComboTour) {
                                                onComboTourCompleted?.();
                                            } else {
                                               handleRecommendation(false)
                                            }
                                        }}
                                    >
                                        {isComboMode && !isLastComboTour
                                            ? "次のツアーを予約"
                                            : "別のツアーを予約"}
                                    </Button>
                                </div>
                                <div className={"col-12 col-md-6 mb-3"}>

                                    <Button
                                        className={"btnBlock"}
                                        variant="contained"
                                        onClick={handleAfterBooking}
                                    >
                                        {isComboMode && !isLastComboTour
                                            ? "次のツアーを予約"
                                            : "チェックアウト"}
                                    </Button>
                                </div>

                            </div>
                        </div>
                        <div className={s.modalActions}>


                        </div>

                    </div>
                </div>
            )}

        </div>
    );
};

export default BookNow;
